import React from 'react';
import { Button, Heading, Text } from '@makemydeal/dr-ui-bricks-components';

import { CUSTOMER_DETAILS_SUMMARY_CONTENT } from './constants';
import {
    CustomerDetailsSummaryField,
    CustomerDetailsSummaryFields,
    CustomerDetailsSummaryRoot
} from './customerDetailsSummary.style';

export const CustomerDetailsSummary: React.FC<{ customerName: string; email: string; onEdit: () => void }> = ({
    customerName,
    email,
    onEdit
}) => (
    <CustomerDetailsSummaryRoot data-testid="customer-details-summary">
        <CustomerDetailsSummaryFields>
            <CustomerDetailsSummaryField>
                <Heading as="h3" level={6} weight="semibold">
                    {CUSTOMER_DETAILS_SUMMARY_CONTENT.nameLabel}
                </Heading>
                <Text data-testid="customer-details-summary-name" size="base">
                    {customerName}
                </Text>
            </CustomerDetailsSummaryField>
            <CustomerDetailsSummaryField>
                <Heading as="h3" level={6} weight="semibold">
                    {CUSTOMER_DETAILS_SUMMARY_CONTENT.emailLabel}
                </Heading>
                <Text data-testid="customer-details-summary-email" size="base">
                    {email}
                </Text>
            </CustomerDetailsSummaryField>
        </CustomerDetailsSummaryFields>
        <Button
            data-testid="customer-details-summary-edit-button"
            buttonStyle="secondary"
            buttonSize="small"
            width="auto"
            onClick={onEdit}
        >
            {CUSTOMER_DETAILS_SUMMARY_CONTENT.actionLabel}
        </Button>
    </CustomerDetailsSummaryRoot>
);
